import { useState } from 'react'
import { useAuth, estSuperadmin } from '../lib/auth'
import { useHistorique } from '../lib/historique'
import { Cloche } from '../components/Cloche'
import { EtatSync } from '../components/EtatSync'
import { LogoComplet } from '../components/Icones'
import { Utilisateurs } from './Utilisateurs'
import { modulesDisponibles, type CleModule } from '../lib/modules'

/**
 * Écran d'accueil : une tuile par module accessible selon le rôle.
 * Affiché seulement aux personnes qui ont au moins deux modules.
 */
export function Accueil({
  ouvrir,
  aller
}: {
  ouvrir: (m: CleModule) => void
  aller: (chantierId: string, suiviId: string | null) => void
}) {
  const { profil, deconnexion } = useAuth()
  const [utilisateurs, setUtilisateurs] = useState(false)
  useHistorique(utilisateurs, setUtilisateurs)
  const modules = modulesDisponibles(profil)

  return (
    <div className="app">
      <header className="entete">
        <div className="entete-logo logo-centre">
          <LogoComplet hauteur={48} />
        </div>
        <div className="entete-rang">
          <div style={{ flex: 1 }}>
            <h1>Accueil</h1>
            <p className="sous">
              {profil?.nom} · {libelleRole(profil?.role)}
            </p>
          </div>
          <EtatSync />
          <Cloche aller={aller} />
        </div>
      </header>

      <div className="corps">
        <div className="tuiles">
          {modules.map((m) => (
            <button key={m.cle} className="tuile" onClick={() => ouvrir(m.cle)}>
              <span className="tuile-nom">{m.nom}</span>
              <span className="tuile-desc">{m.description}</span>
            </button>
          ))}
        </div>

        {estSuperadmin(profil) && (
          <button className="bouton creux" style={{ marginTop: 22 }} onClick={() => setUtilisateurs(true)}>
            Utilisateurs et journal
          </button>
        )}
        <button className="bouton creux" style={{ marginTop: 10 }} onClick={() => void deconnexion()}>
          Se déconnecter
        </button>
        {utilisateurs && <Utilisateurs fermer={() => setUtilisateurs(false)} />}

        <p className="code" style={{ textAlign: 'center', marginTop: 18, opacity: 0.7 }}>
          Version du {__VERSION__}
        </p>
      </div>
    </div>
  )
}

export function libelleRole(r: string | undefined): string {
  if (r === 'superadmin') return 'superadmin'
  if (r === 'admin') return 'administrateur'
  if (r === 'chef') return "chef d'équipe"
  return 'consultation'
}
